/** Project keys: 2–10 uppercase letters/digits, starting with a letter (DOM, WEB2). */
export const KEY_PATTERN = /^[A-Z][A-Z0-9]{1,9}$/;

/**
 * Suggest a key from a project name: initials for multi-word names
 * ("Mind the Dust" → "MTD"), otherwise the first letters ("Platform" → "PLAT").
 * Accents are dropped ("Überblick" → "UBER"); the key can't start with a digit
 * ("2fa service" → "FS") but may contain one ("web app 2" → "WA2").
 */
export function suggestKey(name: string): string {
  const words = name
    .normalize('NFKD')
    .replace(/\p{M}/gu, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, ' ')
    .split(' ')
    .map((w, i) => (i === 0 ? w.replace(/^[0-9]+/, '') : w))
    .filter(Boolean);
  const first = words[0] ?? '';
  const key = words.length > 1 ? words.map((w) => w[0]).join('') : first.slice(0, 4);
  return (key.length >= 2 ? key : `${key}XX`.slice(0, Math.max(2, key.length + 2))).slice(0, 10);
}
